/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Specifies the base multiplier for input values. For example, if this is set to MILLIONS, an input of 200 dollars will be seen as 200 million dollars in the later calculations.
 */
export enum ValuationNumberFormat {
    UNFORMATTED = 'UNFORMATTED',
    THOUSANDS = 'THOUSANDS',
    MILLIONS = 'MILLIONS',
    BILLIONS = 'BILLIONS',
}
